export default __webpack_public_path__ + "static/media/ARIAL.5afb1f7c.ttf";